export const clipboard = (copyData: string) => {
  navigator.permissions.query({name: 'clipboard-write' as PermissionName}).then((result) => {
    if (result.state === 'granted' || result.state === 'prompt') {
      navigator.clipboard.writeText(copyData)
    }
  })
}
